function App() {
  return (
    <div className="min-h-screen bg-black text-white font-nunito">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-4xl md:text-6xl font-bold mb-4">
          Hello there Jackie boi
        </h1>
        <p className="text-xl md:text-2xl font-light text-gray-300 mb-8">
          You finally decided to get the domain. I've bought it for you already, just text me.
        </p>
        <p className="text-lg font-medium text-gray-400">
          You know who~
        </p>
      </div>
    </div>
  );
}

export default App;
